import http from "../../http"
import {API_V1_URL} from "../../constants/other"

const NOTIFICATION_URL = `${API_V1_URL}/notifications`

export const requestOvertimeCoeff = (data) => http.post(`${NOTIFICATION_URL}/request-overtime-coefficient`, {data})
